import type { HTMLProps, PropsWithChildren } from 'react';

export enum HEADING_CONST {
  TEST_ID = 'heading',
}

type HeadingLevels = 1 | 2 | 3 | 4 | 5 | 6;

interface IHeadingProps extends Omit<HTMLProps<HTMLHeadingElement>, 'as'> {
  /**
   * Automatically renders the heading tag based on level
   */
  as?: HeadingLevels;
  color?: string;
  /**
   * Define the level of a heading tag between 1-6
   */
  level: HeadingLevels;
  textAlign?: 'center' | 'left' | 'right';
  link?: string;
  trackClick?: () => void;
}

export type HeadingProps = PropsWithChildren<IHeadingProps>;
